import moment from 'moment';

// Types
import { TimesheetEntry } from './types';

/**
 * Takes a timesheet entry and turns it into a human readable conflict error
 * @param timesheetEntry - the existing timesheet entry causing the conflict
 */
const formatTimeConflictError = (timesheetEntry: TimesheetEntry): string => {
    const {
        personFirstName,
        personLastName,
        workTypeName,
        entityName,
        date,
        startTime,
        endTime
    } = timesheetEntry;

    // If any fields don't exist, return a generic error
    if (
        !personFirstName ||
        !personLastName ||
        !workTypeName ||
        !entityName ||
        !date ||
        !startTime ||
        !endTime
    ) {
        return 'Time conflict';
    }

    const personFullName = `${personFirstName} ${personLastName}`;
    const formattedDate = moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY');
    const formattedStartTime = moment(startTime, 'HH:mm:ss').format('h:mm a');
    const formattedEndTime = moment(endTime, 'HH:mm:ss').format('h:mm a');

    return `${personFullName} is already performing "${workTypeName}" in ${entityName} on ${formattedDate}, from ${formattedStartTime} - ${formattedEndTime}`;
};

export default formatTimeConflictError;
